import { SkaldElement } from '@skaldaura/devkit'
import Catalogue, { IPopulatedCatalogue } from 'components/catalogue/catalogue'
import Produit, { IPopulatedProduct } from 'pages/visiteur/gamme/produit'
import { useEffect, useState } from 'react'

interface IProps {
   categorie: SkaldElement
   color: string
   lang: string
}

export default function Categorie({ categorie, color, lang }: IProps) {
   const [catalogue, setCatalogue] = useState<IPopulatedCatalogue>()
   const [produits, setProduits] = useState<IPopulatedProduct[]>([])

   useEffect(() => {
      categorie
         .getPopulatedSubgroups('Produit')
         .then((products: IPopulatedProduct[]) => setProduits([...products]))

      categorie
         .getPopulatedSubgroups('Catalogue')
         .then((catalogues: IPopulatedCatalogue[]) => setCatalogue(catalogues[0]))
   }, [categorie])

   return (
      <div className='flex between w100'>
         <div className='blocProduit' style={{ width: 530, left: -15 }}>
            {produits.map((produit: IPopulatedProduct) => {
               let video: string | undefined = undefined
               if (produit.titre) {
                  switch (produit.titre[0].value.toLocaleLowerCase()) {
                     case 'silk':
                        video =
                           '/video/Silk, Aptar Beauty + Home is Inventing the Ultimate Spray.mp4'
                  }
               }
               return (
                  <Produit
                     produit={produit}
                     key={produit.titre ? produit.titre[0].subelementid : ''}
                     video={video}
                  />
               )
            })}
         </div>
         {catalogue && (
            <Catalogue lang={lang} catalogue={catalogue} label={categorie.value} color={color} />
         )}
      </div>
   )
}
